import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.stats');
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-admin-stats',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.stats/view.scss */
:host {
  display: block;
  height: 100%;
  width: 100%;
}

.admin-page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 16px;
}

.admin-page__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 220ms ease, transform 220ms ease, visibility 220ms ease;
}

.admin-page__content.is-hidden {
  visibility: hidden;
  pointer-events: none;
  opacity: 0;
  transform: translateY(4px);
}

.admin-page__loading {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 24px;
  background: rgba(248, 250, 252, 0.86);
  backdrop-filter: blur(10px);
}

.admin-page__loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.admin-page__loading-title {
  color: #18181b;
  font-size: 14px;
  font-weight: 700;
}

.admin-page__loading-copy {
  color: #71717a;
  font-size: 12px;
}

.stats-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.stats-header__sub {
  margin-top: 4px;
  color: #71717a;
  font-size: 12px;
}

.stats-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.stats-preset-group,
.stats-range-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stats-preset-btn,
.stats-apply-btn {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
}

.stats-preset-btn.is-active,
.stats-apply-btn {
  border-color: #059669;
  background: #059669;
  color: #ffffff;
}

.stats-preset-btn:hover:not(.is-active),
.stats-date-input:hover {
  border-color: #cbd5e1;
}

.stats-date-input {
  min-height: 36px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #27272a;
  font-size: 12px;
}

.stats-range-sep {
  color: #a1a1aa;
  font-size: 12px;
}

.stats-error {
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #c2410c;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 12px;
}

.stats-data-note {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-radius: 14px;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  color: #0f172a;
}

.stats-data-note__label {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #0369a1;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.stats-data-note__copy {
  color: #334155;
  font-size: 12px;
  line-height: 1.45;
}

.card,
.stats-panel,
.stats-kpi-card {
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  box-shadow: 0 16px 40px -38px rgba(15, 23, 42, 0.35);
}

.stats-panel--month-workspace {
  padding: 18px;
}

.stats-panel__head.stats-panel__head--month-workspace {
  align-items: flex-start;
  margin-bottom: 16px;
}

.stats-panel__meta--month {
  margin-top: 4px;
}

.stats-toggle-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.stats-toggle-group--month {
  flex-shrink: 0;
}

.stats-toggle-btn {
  min-height: 34px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
}

.stats-toggle-btn:hover:not(.is-active) {
  border-color: #cbd5e1;
}

.stats-toggle-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
  color: #ffffff;
}

.stats-month-toolbar {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) auto minmax(180px, 1fr) minmax(160px, 0.8fr);
  gap: 10px;
  align-items: end;
  margin-bottom: 14px;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.stats-month-toolbar__bridge {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.stats-month-toolbar__formula {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
}

.stats-select-box {
  min-width: 0;
}

.stats-select-box__label {
  margin-bottom: 6px;
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
}

.stats-select-box__control {
  width: 100%;
  min-height: 36px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #27272a;
  font-size: 12px;
  font-weight: 600;
}

.stats-select-box__control:hover {
  border-color: #94a3b8;
}

.stats-month-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 14px;
  align-items: start;
}

.stats-month-history,
.stats-month-summary {
  min-width: 0;
}

.stats-month-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.stats-month-section-title {
  color: #09090b;
  font-size: 14px;
  font-weight: 700;
}

.stats-month-summary__pair {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.stats-month-summary__metrics {
  display: grid;
  gap: 10px;
}

.stats-month-summary__metric {
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #fcfcfd;
}

.stats-month-summary__metric-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #111827;
  font-size: 13px;
  font-weight: 700;
}

.stats-month-summary__metric-delta,
.stats-month-summary__difference {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.stats-month-summary__values {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.stats-month-summary__values div {
  min-width: 0;
  padding: 10px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #f1f5f9;
}

.stats-month-summary__values span {
  display: block;
  color: #71717a;
  font-size: 11px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.stats-month-summary__values strong {
  display: block;
  margin-top: 5px;
  color: #09090b;
  font-size: 18px;
  line-height: 1.1;
}

.stats-month-summary__difference {
  width: fit-content;
  margin-top: 10px;
}

.stats-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.stats-kpi-grid--secondary-row {
  margin-top: -2px;
}

.stats-kpi-card {
  padding: 16px 18px;
}

.stats-kpi-card__label {
  color: #71717a;
  font-size: 12px;
}

.stats-kpi-card__value {
  margin-top: 8px;
  color: #09090b;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 700;
}

.stats-kpi-card__delta,
.stats-month-table__delta {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.is-up {
  background: #dcfce7;
  color: #047857;
}

.is-down {
  background: #fee2e2;
  color: #b91c1c;
}

.is-flat {
  background: #f4f4f5;
  color: #52525b;
}

.stats-month-table__delta {
  margin-top: 0;
  justify-self: start;
}

.stats-grid {
  display: grid;
  gap: 14px;
}

.stats-grid--primary {
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 0.75fr) minmax(0, 0.95fr);
}

.stats-grid--secondary {
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
}

.stats-grid--insights {
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.9fr);
  align-items: stretch;
}

.stats-grid--month {
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  align-items: start;
}

.stats-panel {
  padding: 18px;
}

.stats-panel-stack {
  display: grid;
  gap: 14px;
  align-items: stretch;
}

.stats-panel-stack--charts {
  grid-template-columns: 1fr;
}

.stats-panel--wide {
  min-height: 360px;
}

.stats-panel--chart {
  min-height: 360px;
}

.stats-panel--chart-short {
  min-height: 300px;
}

.stats-panel--side {
  min-height: 360px;
  display: flex;
  flex-direction: column;
}

.stats-panel--compact {
  min-height: 168px;
}

.stats-panel--keyword {
  min-height: 178px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stats-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.stats-panel__title {
  color: #09090b;
  font-size: 15px;
  font-weight: 700;
}

.stats-panel__meta {
  color: #71717a;
  font-size: 11px;
}

.stats-stack {
  display: grid;
  gap: 14px;
}

.stats-chart {
  position: relative;
  height: 280px;
}

.stats-chart--short {
  height: 250px;
}

.stats-empty {
  min-height: 180px;
  border: 1px dashed #d4d4d8;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a1a1aa;
  font-size: 12px;
}

.stats-mix-list,
.stats-keyword-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-keyword-list {
  flex: 1;
}

.stats-mix-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fcfcfd;
}

.stats-mix-row__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
}

.stats-mix-row__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #d4d4d8;
}

.stats-mix-row__dot.is-faq {
  background: #6366f1;
}

.stats-mix-row__dot.is-llm {
  background: #10b981;
}

.stats-mix-row__value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  color: #71717a;
  font-size: 11px;
}

.stats-mix-row__value strong {
  color: #09090b;
  font-size: 14px;
}

.stats-keyword-row {
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fcfcfd;
}

.stats-keyword-row__head {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}

.stats-keyword-row__rank {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ecfdf5;
  color: #059669;
  font-size: 11px;
  font-weight: 700;
}

.stats-keyword-row__text {
  color: #111827;
  font-size: 13px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.stats-keyword-row__count {
  color: #71717a;
  font-size: 11px;
}

.stats-keyword-row__track {
  margin-top: 10px;
  height: 8px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.stats-keyword-row__fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #34d399 0%, #10b981 100%);
}

.stats-keyword-pager {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.stats-keyword-pager__btn {
  min-height: 32px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
}

.stats-keyword-pager__btn:hover:not(:disabled) {
  border-color: #a7f3d0;
  color: #047857;
  background: #f0fdf4;
}

.stats-keyword-pager__btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.stats-month-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stats-month-table__row {
  display: grid;
  grid-template-columns: minmax(118px, 1.1fr) repeat(4, minmax(72px, 0.8fr)) minmax(126px, 0.9fr);
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fcfcfd;
  color: #111827;
  font-size: 12px;
}

.stats-month-table__row.is-current {
  border-color: #5eead4;
  background: #f0fdfa;
}

.stats-month-table__row.is-reference {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.stats-month-table__row--head {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.stats-month-table__month {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stats-month-table__month strong {
  color: #111827;
  font-size: 12px;
  line-height: 1.25;
}

.stats-month-table__month small {
  width: fit-content;
  min-height: 22px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: #ffffff;
  color: #0f766e;
  font-size: 10px;
  font-weight: 800;
}

.stats-month-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.stats-month-row-actions__btn {
  min-height: 30px;
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
}

.stats-month-row-actions__btn:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
  background: #f0fdfa;
}

.stats-month-row-actions__btn.is-selected {
  border-color: #0f766e;
  background: #0f766e;
  color: #ffffff;
}

.stats-month-row-actions__btn:disabled {
  cursor: default;
  opacity: 1;
}

.stats-month-table__row--head .stats-month-table__delta {
  margin-top: 0;
  min-height: auto;
  padding: 0;
  background: transparent;
  color: inherit;
}

@media (max-width: 1380px) {
  .stats-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .stats-month-workspace {
    grid-template-columns: 1fr;
  }
  .stats-month-summary__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .stats-grid--insights {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 820px) {
  .stats-grid--insights {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 980px) {
  .stats-header,
  .stats-filter-bar,
  .stats-range-group {
    flex-direction: column;
    align-items: stretch;
  }
  .stats-preset-group {
    flex-wrap: wrap;
  }
  .stats-data-note {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .stats-data-note__label {
    width: fit-content;
  }
  .stats-kpi-grid,
  .stats-month-summary__metrics,
  .stats-month-summary__values {
    grid-template-columns: 1fr;
  }
  .stats-grid--secondary,
  .stats-grid--insights {
    grid-template-columns: 1fr;
  }
  .stats-panel__head.stats-panel__head--month-workspace {
    flex-direction: column;
    align-items: stretch;
  }
  .stats-toggle-group {
    flex-wrap: wrap;
  }
  .stats-month-toolbar {
    grid-template-columns: 1fr;
  }
  .stats-month-toolbar__bridge {
    min-height: auto;
    justify-content: flex-start;
  }
  .stats-month-toolbar__formula {
    min-height: auto;
    justify-content: flex-start;
    text-align: left;
  }
  .stats-month-table__row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .stats-month-table__row--head {
    display: none;
  }
  .stats-month-table__row:not(.stats-month-table__row--head) > span:not(.stats-month-table__month):not(.stats-month-row-actions) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.7);
  }
  .stats-month-table__row:not(.stats-month-table__row--head) > span:nth-child(2)::before {
    content: attr(data-label);
    color: #71717a;
    font-size: 11px;
    font-weight: 700;
  }
  .stats-month-table__row:not(.stats-month-table__row--head) > span:nth-child(3)::before {
    content: attr(data-label);
    color: #71717a;
    font-size: 11px;
    font-weight: 700;
  }
  .stats-month-table__row:not(.stats-month-table__row--head) > span:nth-child(4)::before {
    content: attr(data-label);
    color: #71717a;
    font-size: 11px;
    font-weight: 700;
  }
  .stats-month-table__row:not(.stats-month-table__row--head) > span:nth-child(5)::before {
    content: attr(data-label);
    color: #71717a;
    font-size: 11px;
    font-weight: 700;
  }
  .stats-month-table__month,
  .stats-month-row-actions {
    grid-column: 1/-1;
  }
  .stats-month-row-actions {
    justify-content: flex-start;
  }
}`],
})
export class PageAdminStatsComponent implements OnInit, OnDestroy {
    public loaded: boolean = false;
    public busy: boolean = false;
    public error: string = '';
    public preset: string = '30d';
    public startDate: string = '';
    public endDate: string = '';
    public window: any = {};
    public current: any = {};
    public previous: any = {};
    public compare: any = {};
    public daily: any[] = [];
    public hourly: any[] = [];
    public monthly: any[] = [];
    public keywords: any[] = [];
    public monthCompare: any = {};
    public metricCards: any[] = [];
    public statsMeta: any = {};
    public keywordPage: number = 1;
    public monthCompareMode: 'period' | 'cumulative' = 'period';
    public monthCurrentIndex: number = -1;
    public monthReferenceIndex: number = -1;
    public readonly keywordPageSize: number = 5;
    private dailyChart: Chart | null = null;
    private hourlyChart: Chart | null = null;
    private loadSeq: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        this.setPresetRange('30d');
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyCharts();
    }

    public setPresetRange(preset: string) {
        this.preset = preset;
        const end = new Date();
        end.setHours(12, 0, 0, 0);
        let start = new Date(end.getTime());
        if (preset === 'today') start = new Date(end.getTime());
        else if (preset === '7d') start.setDate(end.getDate() - 6);
        else if (preset === '30d') start.setDate(end.getDate() - 29);
        else if (preset === '90d') start.setDate(end.getDate() - 89);
        else if (preset === 'thisMonth') start = new Date(end.getFullYear(), end.getMonth(), 1, 12, 0, 0, 0);
        this.startDate = this.formatDateInput(start);
        this.endDate = this.formatDateInput(end);
    }

    public async changePreset(preset: string) {
        this.setPresetRange(preset);
        await this.load();
    }

    public async applyRange() {
        if (!this.startDate || !this.endDate) {
            this.service.alert('기간을 선택해 주세요.');
            return;
        }
        if (this.startDate > this.endDate) {
            const temp = this.startDate;
            this.startDate = this.endDate;
            this.endDate = temp;
        }
        this.preset = 'custom';
        await this.load();
    }

    public async load() {
        const seq = ++this.loadSeq;
        this.busy = true;
        this.loaded = false;
        this.error = '';
        this.destroyCharts();
        this.resetStats();
        await this.service.render();
        try {
            const res = await this.service.apiHarness('stats', 'overview', {
                start_date: this.startDate,
                end_date: this.endDate,
                sections: 'summary',
            }, { cacheTtlMs: 10000, timeoutMs: 15000 });
            if (seq !== this.loadSeq) return;
            this.applySummary(res);
            this.loaded = true;
            await this.service.render();
            this.loadDeferredSections(seq).catch(() => { });
        } catch (e: any) {
            if (seq !== this.loadSeq) return;
            this.error = e?.message || String(e);
            this.metricCards = [];
            this.monthCompare = {};
            this.busy = false;
            this.loaded = true;
            await this.service.render();
        }
    }

    public monthCompareItems() {
        if (!this.monthCompare?.current_label) return [];
        return [
            { label: this.chatUnitLabel(), data: this.monthCompare.total_visit },
            { label: '페이지 방문', data: this.monthCompare.visit_count },
            { label: '고유 방문 IP', data: this.monthCompare.unique_ip },
            { label: '질문', data: this.monthCompare.total_q },
        ];
    }

    public chatUnitLabel(): string {
        return String(this.statsMeta?.session_metric?.label || '채팅 세션');
    }

    public chatDeltaLabel(): string {
        return String(this.statsMeta?.session_metric?.delta_label || '채팅 증감');
    }

    public legacySessionNotice(): string {
        return String(this.statsMeta?.session_metric?.notice || '');
    }

    public topMetricCards() {
        return this.metricCards.slice(0, 4);
    }

    public secondaryMetricCards() {
        return this.metricCards.slice(4, 8);
    }

    public monthCompareOptions() {
        return this.monthly.map((row: any, index: number) => ({
            index,
            label: this.monthDisplayLabel(row),
        }));
    }

    public responseMixRows() {
        return [
            { label: 'FAQ', count: Number(this.current?.faq_count || 0), ratio: Number(this.current?.faq_ratio || 0), tone: 'faq' },
            { label: 'LLM', count: Number(this.current?.llm_count || 0), ratio: Number(this.current?.llm_ratio || 0), tone: 'llm' },
        ];
    }

    public formatNumber(value: any): string {
        if (value === null || value === undefined || value === '') return '-';
        return new Intl.NumberFormat('ko-KR').format(Number(value || 0));
    }

    public formatPct(value: any): string {
        return `${Number(value || 0).toFixed(1)}%`;
    }

    public formatMs(value: any): string {
        const ms = Number(value || 0);
        if (!ms) return '-';
        return `${(ms / 1000).toFixed(1)}초`;
    }

    public deltaClass(item: any): string {
        const direction = String(item?.direction || 'flat');
        if (direction === 'up') return 'is-up';
        if (direction === 'down') return 'is-down';
        return 'is-flat';
    }

    public deltaText(item: any, mode: string = 'pct'): string {
        if (!item) return '비교 없음';
        if (item.unavailable) return '측정 불가';
        if (item.previous === 0 && item.current > 0 && item.delta_pct === null) return '신규';
        if (mode === 'point') {
            const delta = Number(item.delta || 0);
            if (!delta) return '0.0%p';
            return `${delta > 0 ? '+' : ''}${delta.toFixed(1)}%p`;
        }
        if (mode === 'ms') {
            const delta = Number(item.delta || 0);
            if (!delta) return '0ms';
            return `${delta > 0 ? '+' : ''}${this.formatMs(Math.abs(delta))}`;
        }
        if (item.delta_pct === null || item.delta_pct === undefined) return '비교 없음';
        const deltaPct = Number(item.delta_pct || 0);
        return `${deltaPct > 0 ? '+' : ''}${deltaPct.toFixed(1)}%`;
    }

    public monthDeltaText(value: any): string {
        if (value === null || value === undefined) return '-';
        const num = Number(value || 0);
        return `${num > 0 ? '+' : ''}${num.toFixed(1)}%`;
    }

    public monthDeltaClass(value: any): string {
        if (value === null || value === undefined) return 'is-flat';
        const num = Number(value || 0);
        if (num > 0) return 'is-up';
        if (num < 0) return 'is-down';
        return 'is-flat';
    }

    public monthDeltaCountText(item: any): string {
        if (!item) return '0';
        const delta = Number(item.delta || 0);
        if (!delta) return '0';
        return `${delta > 0 ? '+' : ''}${this.formatNumber(delta)}`;
    }

    public monthDisplayLabel(row: any): string {
        const raw = String(row?.month || '').trim();
        const parts = raw.split('-');
        if (parts.length === 2) {
            return `${parts[0]}년 ${Number(parts[1])}월`;
        }
        return String(row?.label || raw || '-');
    }

    public async changeMonthCompareMode(mode: 'period' | 'cumulative') {
        if (this.monthCompareMode === mode) return;
        this.monthCompareMode = mode;
        this.syncMonthCompareState();
        await this.service.render();
    }

    public async changeMonthSelection(target: 'current' | 'reference', index: any) {
        const nextIndex = Number(index);
        if (!Number.isFinite(nextIndex) || nextIndex < 0 || nextIndex >= this.monthly.length) return;

        if (target === 'current') this.monthCurrentIndex = nextIndex;
        else this.monthReferenceIndex = nextIndex;

        if (this.monthCurrentIndex === this.monthReferenceIndex && this.monthly.length > 1) {
            if (target === 'current') {
                this.monthReferenceIndex = nextIndex > 0 ? nextIndex - 1 : Math.min(this.monthly.length - 1, nextIndex + 1);
            } else {
                this.monthCurrentIndex = nextIndex < this.monthly.length - 1 ? nextIndex + 1 : Math.max(0, nextIndex - 1);
            }
        }

        this.syncMonthCompareState();
        await this.service.render();
    }

    public isMonthRowCurrent(index: number): boolean {
        return index === this.monthCurrentIndex;
    }

    public isMonthRowReference(index: number): boolean {
        return index === this.monthReferenceIndex;
    }

    public monthRowRoleLabel(index: number): string {
        if (this.isMonthRowReference(index)) return '기준 월';
        if (this.isMonthRowCurrent(index)) return '비교 월';
        return '';
    }

    public keywordBarWidth(item: any): number {
        const max = Math.max(...this.keywords.map((row: any) => Number(row?.count || 0)), 1);
        return Math.max(10, Math.round((Number(item?.count || 0) / max) * 100));
    }

    public pagedKeywords() {
        const start = (this.keywordPage - 1) * this.keywordPageSize;
        return this.keywords.slice(start, start + this.keywordPageSize);
    }

    public keywordMaxPage(): number {
        return Math.max(1, Math.ceil(this.keywords.length / this.keywordPageSize));
    }

    public async keywordGoPage(page: number) {
        if (page < 1 || page > this.keywordMaxPage()) return;
        this.keywordPage = page;
        await this.service.render();
    }

    private buildMetricCards() {
        return [
            {
                label: this.chatUnitLabel(),
                value: this.formatNumber(this.current?.total_visit),
                compare: this.compare?.total_visit,
                deltaMode: 'pct',
                tone: 'emerald',
            },
            {
                label: '페이지 방문',
                value: this.formatNumber(this.current?.visit_count),
                compare: this.compare?.visit_count,
                deltaMode: 'pct',
                tone: 'sky',
            },
            {
                label: '고유 방문 IP',
                value: this.formatNumber(this.current?.unique_ip),
                compare: this.compare?.unique_ip,
                deltaMode: 'pct',
                tone: 'violet',
            },
            {
                label: '질문 수',
                value: this.formatNumber(this.current?.total_q),
                compare: this.compare?.total_q,
                deltaMode: 'pct',
                tone: 'zinc',
            },
            {
                label: '답변 수',
                value: this.formatNumber(this.current?.answered),
                compare: this.compare?.answered,
                deltaMode: 'pct',
                tone: 'violet',
            },
            {
                label: '답변률',
                value: this.formatPct(this.current?.answer_rate),
                compare: this.compare?.answer_rate,
                deltaMode: 'point',
                tone: 'amber',
            },
            {
                label: 'FAQ 비율',
                value: this.formatPct(this.current?.faq_ratio),
                compare: this.compare?.faq_ratio,
                deltaMode: 'point',
                tone: 'indigo',
            },
            {
                label: '평균 첫 응답시간',
                value: this.formatMs(this.current?.avg_ttft_ms),
                compare: this.compare?.avg_ttft_ms,
                deltaMode: 'ms',
                tone: 'rose',
            },
            {
                label: 'IP당 질문',
                value: `${Number(this.current?.avg_q_per_visitor || 0).toFixed(1)}건`,
                compare: this.compare?.avg_q_per_visitor,
                deltaMode: 'pct',
                tone: 'teal',
            },
        ];
    }

    private resetStats() {
        this.window = {};
        this.current = {};
        this.previous = {};
        this.compare = {};
        this.daily = [];
        this.hourly = [];
        this.monthly = [];
        this.keywords = [];
        this.monthCompare = {};
        this.metricCards = [];
        this.statsMeta = {};
        this.keywordPage = 1;
        this.monthCurrentIndex = -1;
        this.monthReferenceIndex = -1;
    }

    private applySummary(res: any) {
        this.window = res?.window || {};
        this.current = res?.current || {};
        this.previous = res?.previous || {};
        this.compare = res?.compare || {};
        this.statsMeta = res?.meta || {};
        if (this.window?.start) this.startDate = this.window.start;
        if (this.window?.end) this.endDate = this.window.end;
        this.metricCards = this.buildMetricCards();
        this.syncMonthCompareState();
    }

    private async loadDeferredSections(seq: number) {
        const params = {
            start_date: this.startDate,
            end_date: this.endDate,
        };
        const sections = ['daily', 'hourly', 'monthly', 'keywords'];
        await Promise.all(sections.map((section) => this.loadStatsSection(section, params, seq)));
        if (seq !== this.loadSeq) return;
        this.busy = false;
        await this.service.render();
    }

    private async loadStatsSection(section: string, params: any, seq: number) {
        try {
            const res = await this.service.apiHarness('stats', 'overview', {
                ...params,
                sections: section,
            }, { cacheTtlMs: 10000, timeoutMs: 20000 });
            if (seq !== this.loadSeq) return;
            if (section === 'daily') {
                this.daily = Array.isArray(res?.daily) ? res.daily : [];
                await this.service.render();
                requestAnimationFrame(() => this.renderDailyChart());
                return;
            }
            if (section === 'hourly') {
                this.hourly = Array.isArray(res?.hourly) ? res.hourly : [];
                await this.service.render();
                requestAnimationFrame(() => this.renderHourlyChart());
                return;
            }
            if (section === 'monthly') {
                this.monthly = Array.isArray(res?.monthly) ? res.monthly : [];
                this.monthCompare = res?.month_compare || {};
                this.syncMonthCompareState();
                await this.service.render();
                return;
            }
            if (section === 'keywords') {
                this.keywords = Array.isArray(res?.keywords) ? res.keywords : [];
                this.keywordPage = Math.min(this.keywordPage, this.keywordMaxPage());
                if (this.keywordPage < 1) this.keywordPage = 1;
                await this.service.render();
            }
        } catch (e: any) {
            if (seq !== this.loadSeq) return;
            const message = e?.message || String(e);
            this.error = this.error || `일부 통계 데이터를 불러오지 못했습니다. (${message})`;
            await this.service.render();
        }
    }

    private syncMonthCompareState() {
        if (this.monthly.length < 2) {
            this.monthCurrentIndex = -1;
            this.monthReferenceIndex = -1;
            this.monthCompare = {};
            return;
        }

        if (this.monthCurrentIndex < 0 || this.monthCurrentIndex >= this.monthly.length) {
            this.monthCurrentIndex = this.monthly.length - 1;
        }
        if (this.monthReferenceIndex < 0 || this.monthReferenceIndex >= this.monthly.length) {
            this.monthReferenceIndex = Math.max(0, this.monthCurrentIndex - 1);
        }
        if (this.monthCurrentIndex === this.monthReferenceIndex) {
            this.monthReferenceIndex = this.monthCurrentIndex > 0 ? this.monthCurrentIndex - 1 : this.monthCurrentIndex + 1;
        }

        this.monthCompare = this.buildMonthCompare(this.monthCurrentIndex, this.monthReferenceIndex, this.monthCompareMode);
    }

    private buildMonthCompare(currentIndex: number, referenceIndex: number, mode: 'period' | 'cumulative') {
        const currentRow = this.monthly[currentIndex] || {};
        const previousRow = this.monthly[referenceIndex] || {};
        const current = mode === 'cumulative' ? this.cumulativeMonthRow(currentRow) : currentRow;
        const previous = mode === 'cumulative' ? this.cumulativeMonthRow(previousRow) : previousRow;
        const suffix = mode === 'cumulative' ? ' 누적' : '';

        return {
            mode,
            current_label: `${this.monthDisplayLabel(currentRow)}${suffix}`,
            previous_label: `${this.monthDisplayLabel(previousRow)}${suffix}`,
            total_visit: this.buildCompareMetric(current?.total_visit, previous?.total_visit),
            visit_count: this.buildCompareMetric(current?.visit_count, previous?.visit_count),
            unique_ip: this.buildCompareMetric(current?.unique_ip, previous?.unique_ip),
            total_q: this.buildCompareMetric(current?.total_q, previous?.total_q),
            answered: this.buildCompareMetric(current?.answered, previous?.answered),
        };
    }

    private cumulativeMonthRow(row: any) {
        return {
            total_visit: Number(row?.cumulative_total_visit || row?.total_visit || 0),
            visit_count: Number(row?.cumulative_visit_count || row?.visit_count || 0),
            unique_ip: Number(row?.cumulative_unique_ip || row?.unique_ip || 0),
            total_q: Number(row?.cumulative_total_q || row?.total_q || 0),
            answered: Number(row?.cumulative_answered || row?.answered || 0),
        };
    }

    private buildCompareMetric(currentValue: any, previousValue: any) {
        if (currentValue === null || currentValue === undefined || previousValue === null || previousValue === undefined) {
            return {
                current: currentValue,
                previous: previousValue,
                delta: null,
                delta_pct: null,
                direction: 'flat',
                unavailable: true,
            };
        }
        const current = Number(currentValue || 0);
        const previous = Number(previousValue || 0);
        const delta = current - previous;
        let deltaPct: number | null = null;
        if (previous) deltaPct = Number(((delta / previous) * 100).toFixed(1));
        else if (current === 0) deltaPct = 0;

        let direction = 'flat';
        if (delta > 0) direction = 'up';
        else if (delta < 0) direction = 'down';

        return {
            current,
            previous,
            delta,
            delta_pct: deltaPct,
            direction,
            unavailable: false,
        };
    }

    private formatDateInput(value: Date): string {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private destroyCharts() {
        if (this.dailyChart) {
            this.dailyChart.destroy();
            this.dailyChart = null;
        }
        if (this.hourlyChart) {
            this.hourlyChart.destroy();
            this.hourlyChart = null;
        }
    }

    private renderDailyChart() {
        if (!this.daily.length) return;
        const canvas = document.getElementById('admin-stats-daily-chart') as HTMLCanvasElement | null;
        if (!canvas) return;

        if (this.dailyChart) this.dailyChart.destroy();
        this.dailyChart = new Chart(canvas, {
            type: 'line',
            data: {
                labels: this.daily.map((row: any) => row.label),
                datasets: [
                    {
                        label: '질문',
                        data: this.daily.map((row: any) => Number(row.total_q || 0)),
                        borderColor: '#0f766e',
                        backgroundColor: 'rgba(15, 118, 110, 0.14)',
                        tension: 0.35,
                        fill: true,
                        borderWidth: 3,
                        pointRadius: 4,
                        pointHoverRadius: 7,
                        pointHitRadius: 18,
                        pointBorderWidth: 2,
                        pointHoverBorderWidth: 3,
                        pointBackgroundColor: '#0f766e',
                        pointBorderColor: '#ffffff',
                    },
                    {
                        label: this.chatUnitLabel(),
                        data: this.daily.map((row: any) => Number(row.total_visit || 0)),
                        borderColor: '#ea580c',
                        backgroundColor: 'rgba(234, 88, 12, 0.14)',
                        tension: 0.35,
                        fill: false,
                        borderWidth: 3,
                        pointRadius: 4,
                        pointHoverRadius: 7,
                        pointHitRadius: 18,
                        pointBorderWidth: 2,
                        pointHoverBorderWidth: 3,
                        pointBackgroundColor: '#ea580c',
                        pointBorderColor: '#ffffff',
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                interaction: {
                    mode: 'nearest',
                    intersect: false,
                    axis: 'x',
                },
                plugins: {
                    legend: {
                        position: 'top',
                        align: 'start',
                        labels: { boxWidth: 10, boxHeight: 10, usePointStyle: true },
                    },
                    tooltip: {
                        mode: 'nearest',
                        intersect: false,
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        border: { display: false },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: { precision: 0 },
                        grid: { color: 'rgba(228, 228, 231, 0.8)' },
                        border: { display: false },
                    },
                },
            },
        });
    }

    private renderHourlyChart() {
        if (!this.hourly.length) return;
        const canvas = document.getElementById('admin-stats-hourly-chart') as HTMLCanvasElement | null;
        if (!canvas) return;

        if (this.hourlyChart) this.hourlyChart.destroy();
        this.hourlyChart = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: this.hourly.map((row: any) => row.label),
                datasets: [
                    {
                        label: '질문',
                        data: this.hourly.map((row: any) => Number(row.total_q || 0)),
                        backgroundColor: '#10b981',
                        borderRadius: 6,
                        maxBarThickness: 14,
                    },
                    {
                        label: this.chatUnitLabel(),
                        data: this.hourly.map((row: any) => Number(row.total_visit || 0)),
                        backgroundColor: '#7dd3fc',
                        borderRadius: 6,
                        maxBarThickness: 14,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: {
                        position: 'top',
                        align: 'start',
                        labels: { boxWidth: 10, boxHeight: 10, usePointStyle: true },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        border: { display: false },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: { precision: 0 },
                        grid: { color: 'rgba(228, 228, 231, 0.8)' },
                        border: { display: false },
                    },
                },
            },
        });
    }
}

export default PageAdminStatsComponent;